import * as Sentry from "@sentry/browser";
import dayjs from "dayjs";
import * as utcPlugin from "dayjs/plugin/utc";
import { createRoot } from "react-dom/client";
import App from "./App";

dayjs.extend(utcPlugin.default);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    ignoreErrors: ["ResizeObserver loop limit exceeded"],
    release: process.env.REACT_APP_CI_COMMIT_SHORT_SHA,
  });
  Sentry.setTag("CI_COMMIT_SHORT_SHA", process.env.REACT_APP_CI_COMMIT_SHORT_SHA);
}
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
